<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md2>
        <h1 class="primary--text mb-4">Create Partner</h1>
        <app-alert class="mb-3" type="error" :message="error" @dismissed="error = false" />

        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">
            <span>Partner Details</span>
            <v-spacer></v-spacer>
            <v-icon @click="$router.go(-1)">close</v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-form ref="form" @submit.prevent="doCreateAgency">
            <v-container class="px-4">
              <v-layout justify-space-between row wrap>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Name"
                    type="text"
                    v-model="agency.name"
                    :rules="[rules.isRequired]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    label="Status"
                    v-model="agency.status"
                    :items="statusOptions"
                    :rules="[rules.isRequired]"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Website"
                    type="text"
                    v-model="agency.more"
                    :rules="[rules.isRequired]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    label="Type"
                    v-model="agency.tag"
                    :items="agencyTypeOptions"
                    :rules="[rules.isRequired]"
                    required
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout class="mt-3 mb-3">
                <v-btn depressed color="accent" type="submit" :disabled="isSaving">
                  Create
                  <v-progress-circular
                    class="ml-2"
                    :indeterminate="true"
                    :size="18"
                    :width="2"
                    v-if="isSaving"
                  ></v-progress-circular>
                </v-btn>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { AGENCY_CREATE } from '@/store/actions/agency'
import { statusOptions, agencyTypeOptions } from '@/data/options'

export default {
  name: 'CreateAgency',
  data () {
    return {
      isSaving: false,
      statusOptions: statusOptions,
      agencyTypeOptions: agencyTypeOptions,
      agency: {
        name: '',
        status: 'active',
        more: '',
        tag: '',
        country_id: this.$settings.country
      },
      error: false,
      rules: {
        isRequired: value => this.$validator.isRequired(value)
      }
    }
  },
  methods: {
    doCreateAgency () {
      if (!this.$refs.form.validate()) return
      this.isSaving = true
      this.$store.dispatch(AGENCY_CREATE, this.agency)
        .then(() => this.$router.push('/agencies?agencyCreated=1'))
        .catch(error => (this.error = error.message))
        .finally(() => (this.isSaving = false))
    }
  }
}
</script>
